




import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export default class Home extends Vue {
  @Getter('firstTime') firstTime

  mounted() {
    this.$router.push({ name: 'projects' })
    // if (!this.firstTime) {
    // }
    // this.showLogo()
  }



  // hideLogo() {
  //   this.timeline.to(this.$refs.logo, 1, { alpha: 0, onComplete: this.done })
  // }

  // done() {
  //   this.$router.push({ name: 'projects' })
  // }

  // enter() {
  //   this.timeline.to(this.$refs.logo, 1, { x: -50, y: -50, onComplete: this.hideLogo })
  // }
}
